import { Skeleton } from '../../components/Skeleton';

export function InternalDashboardSkeleton() {
  return <Skeleton className="h-[600px]" />;
}
